import React from 'react';
import ContactForm from '../ContactFrom'
import './style.css'

const Contactpage = () => {

    return(
        <section className="wpo-contact-form-map section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-12">
                        <div className="row">
                            <div className="col col-lg-8 col-12">
                                <div className="contact-form">
                                    <h2>Get In Touch</h2>
                                    <ContactForm/>
                                </div>                            
                            </div>
                            <div className="col col-lg-4 col-12">
                                <div className="wpo-contact-info">
                                    <div className="info-item">
                                        <h2>25 North Street,Dubai</h2>
                                        <div className="info-wrap">
                                            <div className="info-icon">
                                                <i className="fi flaticon-internet"></i>
                                            </div>
                                            <div className="info-text">
                                                <span>Office Address</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="info-item">
                                        <h2>info@edefytheme.com</h2>
                                        <div className="info-wrap">
                                            <div className="info-icon">
                                                <i className="fi flaticon-mail"></i>
                                            </div>
                                            <div className="info-text">
                                                <span>Official Mail</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="info-item">
                                        <h2>+91 256-987-239</h2>
                                        <div className="info-wrap">
                                            <div className="info-icon">
                                                <i className="fi flaticon-support-1"></i>
                                            </div>
                                            <div className="info-text">
                                                <span>Official Phone</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
     )
        
}

export default Contactpage;
